export default __webpack_public_path__ + "static/media/img--design-5.379173da.jpg";